<template>
  
  
  <vx-card :title="companiesGroupDataProp ? companiesGroupDataProp.name : 'Add a new Companies Group'">
    <!-- <div>{{companiesGroupData}}</div> -->
    <!-- <div>{{this.listingDataProp}}</div> -->


    <!-- <v-divider>General Details</v-divider> -->

    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input label="Name *" v-model="companiesGroupData.form.name" class="w-full" />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-full w-full mt-5">
        <h3 style="margin-bottom:10px;">Select the companies you want to have in this group</h3>
        <ul style="display:flex; justify-content: flex-start; flex-wrap: wrap;">
          <li style="width: 30%; flex-grow: 1; margin-right:2%; margin-top:5px;margin-bottom:5px;" v-for="(company, index) in companies" :key="index">
              <vs-checkbox v-model="companiesGroupData.form.selectedCompanies" :vs-value="company.id" >{{ company.name }}</vs-checkbox>
          </li>
        </ul>
      </div>
    </div>
    <div class="vx-row mt-5" style="padding:0 1rem;">
        <div>
          <h5 style="margin-bottom: 10px;">The emails of the companies included in this group:</h5>
         
          <div  v-if="companiesGroupData.form.selectedCompanies.length > 0">
            <transition-group name="fade" mode="out-in">
              <div class="company-emails" v-for="(company,index) in companiesGroupData.form.selectedCompanies" :key="index">
                {{mapCompanyIdToData[company].email}}
              </div>
            </transition-group>
          </div>
          
          <div v-else>
            
              <p style="color: #ff1313;">No companies are added to this group yet</p>
            
          </div>
        </div>
    </div>

    <!-- 
    {{companiesGroupData.form.selectedCompanies}}
    {{mapCompanyIdToData}}
   -->
    <div class="mt-5" style="display: flex; justify-content: flex-end;">
      <vs-button color="primary" type="filled" @click="saveCompanyData">Save</vs-button>
    </div>

  </vx-card>

</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import draggable from 'vuedraggable'
  import ImageUploader from 'vue-image-upload-resize'

    export default {
    name: "AddCompanyComponent",
    components: {
      draggable,
      ImageUploader
    },
    props: {
      companiesGroupDataProp: {
        type: Object
      },
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        backgroundLoading:'primary',
        colorLoading:'#fff',
        mapCompanyIdToData : {},
        companiesGroupData: {
          form: {
            name : null,
            selectedCompanies : []
          },
          formData : new FormData(),
          url: 'admin/companiesGroups',
          storeName: 'companiesGroups',
          hasFormData: true,
        }
      }
    },
    async created() {

      console.log(this.companies)
      //this.$vs.loading.close()
      this.setCompaniesGroupData()
    },
    computed: {
      ...mapGetters({
        companies: 'companies/companiesList',
        isLoading: 'companiesGroups/isLoading',
        error: 'companiesGroups/error',
      }),
    },
  watch: {
    // companies(newCompaniesArr){
    //   console.log(newCompaniesArr)
    //   let vm = this;
    //   newCompaniesArr.forEach(company => {
    //     vm.mapCompanyIdToData[company.id] = company
    //   })  
    // }
  },
    methods: {
      ...mapActions({
        add: 'add'
      }),
      setCompaniesGroupData() {

        let vm = this;
          this.companies.forEach(company => {
            vm.mapCompanyIdToData[company.id] = company
          })

        if (this.isEdit) {
          this.companiesGroupData.form.name = this.companiesGroupDataProp.name
          this.companiesGroupData.form.selectedCompanies = this.companiesGroupDataProp.companies.map(company => company.id)
          this.companiesGroupData.url = `admin/companiesGroups/${this.$route.params.companiesGroupID}`
        }
      },

      
      async saveCompanyData() {
        const vm = this;

        Object.entries(this.companiesGroupData.form).forEach(([key, value]) => {
          if(key === 'selectedCompanies'){
            this.companiesGroupData.formData.append(key, JSON.stringify(value));
          }
          else{
            this.companiesGroupData.formData.append(key, value);

          }
        });

        console.log(this.companiesGroupData)
        this.$vs.loading({ text: 'Saving Companies Group Data' })
        this.add(this.companiesGroupData).then((response) => {
          this.successNotify(response.data.message)
          console.log(response.data)
          this.$router.replace({
            name: 'Companies Groups'
          })
        }).catch((error) => {
          console.log(error);
          this.errorNotify(error)
        }).finally(() => {
          this.$vs.loading.close()
        })
      },
      errorNotify(msg){
        this.$vs.notify({color:'danger',title:'Error',text:msg})
      },
      successNotify(msg){
        this.$vs.notify({color:'success',title:'Success',text:msg})
      },
    },
  }
</script>

<style scoped>
 .company-emails{
    display: inline-block;
    background: rgb(51 162 238);
    color: #ffffff;
    padding: 10px 25px;
    border-radius: 5px 25px;
    margin-bottom: 5px;
    margin-right: 5px;
 }

.fade-enter {
  opacity:0;
}

.fade-enter-active{
  animation: fadein 0.1s;
}

.fade-leave {
  opacity:1;
}

.fade-leave-active {
  animation: fadein 0.1s reverse;
}


@keyframes fadein {
  from {opacity: 0;}
  to   {opacity: 1;}
}

</style>
